
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UICollapsible',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    initialCollapsed: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: [String, Number],
      default: 'max-h-96'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: () => `collapsible-${Math.random().toString(36).substring(2, 9)}`
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.initialCollapsed
    }
  },
  computed: {
    headingId() {
      return `${this.id}-heading`
    },
    contentId() {
      return `${this.id}-content`
    },
    componentBindings() {
      return this.disabled
        ? {}
        : {
            type: 'button',
            'aria-expanded': !this.isCollapsed,
            'aria-controls': this.contentId,
            'aria-label': 'Toggle section visibility'
          }
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
      this.$emit('toggle', !this.isCollapsed)
    }
  }
})
